import React from "react";
import {ComponentPropsFromRoute} from "../../routers/routers";
import {RouteButtons} from "../common/route-tabs/route.buttons";
import {Space, Typography} from "antd";
import {useTranslate} from "../../hooks/translate.hook";

export const Articles: React.FC<ComponentPropsFromRoute> = ({routeChildren}) => {
    const t = useTranslate();

    return (
        <Space direction={"vertical"}>
            <Typography.Title level={3} className="reports-main-page__title">
                {t("ARTICLES.TITLE")}
            </Typography.Title>
            <RouteButtons routes={routeChildren || []}/>
        </Space>
    )
}